import { render, staticRenderFns } from "./OrderNotifications.vue?vue&type=template&id=2cde7ed2"
import script from "./OrderNotifications.vue?vue&type=script&lang=js"
export * from "./OrderNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports